import { AccountCircle } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";

const GlobalFilter = ({state, setGlobalFilter, preGlobalFilteredRows,}) => {
  const {globalFilter} = state
  const [value, setValue] = useState(globalFilter);
  return (

    <Box
      justifyContent={"center"}
      zIndex={10000}
      position="fixed"
      top="0"
      sx={{
        width: {
          xs: "100%",
          md: "70%",
        },
        py: "1em",
        display:{
          xs:'none',
          md:'flex'
        }
      }}
    >
      <Box display="flex" justifyContent={"center"} width="50%" flexGrow={1}>
        <TextField
          id="searchbar"
          value={value}
          sx={{
            borderRadius: "1000px",
            width: "100%",
            maxWidth: "250px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "1000px",
            },
          }}
          placeholder="Search.."
          onChange={
            e => {
              setValue(e.target.value);
              setGlobalFilter(e.target.value || undefined)
            }
          }
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <i class="las la-search la-lg"></i>
              </InputAdornment>
            ),
            endAdornment: globalFilter && (
            
              <InputAdornment position="end" sx={{cursor:'pointer'}} onClick={()=>{
                setGlobalFilter('')
                setValue('')
                }}>
             <i class="las la-times la-lg"></i>
            </InputAdornment>
            )
          }}
        />
      </Box>
    </Box>
  );
};

export default GlobalFilter;
